/**
 * carryingAffirmation.js — a one-shot handoff from Rituals (or Home) to
 * the Journal page.
 *
 * When a member taps "Carry into Journal" on an affirmation we stash the
 * affirmation in `sessionStorage` and route them to `/journal`. The
 * Journal page reads it ONCE on mount via `consumeCarryingAffirmation()`
 * which clears the key — so returning to Journal normally does not
 * re-render the panel, and the member's actual journal entry is never
 * pre-filled.
 *
 * We use sessionStorage (not query params) so the affirmation isn't
 * surfaced in the URL, and so the panel vanishes on reload.
 */
const KEY = "n8one.carrying-affirmation.v1";

export function setCarryingAffirmation({ text, category }) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ text: text || "", category: category || "", at: Date.now() }),
    );
  } catch { /* noop */ }
}

/** Read and clear in a single call. Returns null if nothing was set. */
export function consumeCarryingAffirmation() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    localStorage.removeItem(KEY);
    const parsed = JSON.parse(raw);
    if (!parsed?.text) return null;
    return parsed;
  } catch { return null; }
}
